export default "__VITE_ASSET__CsxbFXml__"